import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Terminos() {
  return (
    <LegalLayout title="Términos y Condiciones" updated="Junio de 2026">
      <p data-testid="terminos-intro" className="text-[15px]" style={{ color: "#444" }}>
        Bienvenido a Vinonotas. Al acceder y utilizar esta plataforma aceptas los siguientes Términos y
        Condiciones. Te recomendamos leerlos con atención. Si no estás de acuerdo con ellos, por favor no
        utilices el servicio.
      </p>

      <LegalSection title="1. Edad legal">
        <p>
          Vinonotas contiene contenido relacionado con bebidas alcohólicas. Para registrarte y utilizar el
          servicio debes ser mayor de edad legal para el consumo de alcohol en tu país de residencia. Al crear
          una cuenta confirmas que cumples con este requisito.
        </p>
      </LegalSection>

      <LegalSection title="2. Uso del servicio">
        <p>
          Vinonotas es una herramienta para registrar, organizar y comparar notas de cata de vino con fines
          personales y profesionales. Te comprometes a utilizar la plataforma de forma lícita y a no emplearla
          para fines fraudulentos, ilegales o que infrinjan derechos de terceros.
        </p>
      </LegalSection>

      <LegalSection title="3. Cuenta de usuario">
        <p>
          Eres responsable de mantener la confidencialidad de tus credenciales de acceso y de toda la actividad
          que ocurra en tu cuenta. Debes notificarnos de inmediato ante cualquier uso no autorizado.
        </p>
      </LegalSection>

      <LegalSection title="4. Contenido del usuario">
        <p>
          Conservas la titularidad de las notas de cata, imágenes y datos que introduces. Nos concedes una
          licencia limitada para almacenar y procesar dicho contenido con el único fin de prestarte el servicio.
        </p>
      </LegalSection>

      <LegalSection title="5. Planes y límites">
        <p>
          El plan gratuito permite registrar un número limitado de catas. Los planes de pago ofrecen
          funcionalidades ampliadas. Las condiciones y precios podrán actualizarse notificándolo con antelación.
        </p>
      </LegalSection>

      <LegalSection title="6. Asistente de IA (Somm Vinonotas)">
        <p>
          Las sugerencias generadas por el asistente de inteligencia artificial tienen carácter orientativo. No
          garantizamos su exactitud y no sustituyen el criterio profesional del catador.
        </p>
      </LegalSection>

      <LegalSection title="7. Limitación de responsabilidad">
        <p>
          El servicio se ofrece "tal cual". En la medida permitida por la ley, Vinonotas no será responsable de
          daños derivados del uso o la imposibilidad de uso de la plataforma. Bebe siempre con moderación.
        </p>
      </LegalSection>

      <LegalSection title="8. Modificaciones">
        <p>
          Podremos actualizar estos Términos en cualquier momento. El uso continuado del servicio tras dichos
          cambios implica su aceptación.
        </p>
      </LegalSection>

      <LegalSection title="9. Contacto">
        <p>Para cualquier consulta sobre estos Términos, puedes escribirnos a través de los canales de contacto oficiales de Vinonotas.</p>
      </LegalSection>
    </LegalLayout>
  );
}
